{
    "Profile_Dwellings_Dwelling.dwellingDetails": "Dwelling Details",
    "Profile_Dwellings_Dwelling.number": "Number",
    "Profile_Dwellings_Dwelling.principalUnit": "Principal Unit",
    "Profile_Dwellings_Dwelling.replacementCost": "Replacement Cost",
    "Profile_Dwellings_Dwelling.numberOfLossPayees": "Number of Loss Payees",
    "Profile_Dwellings_Dwelling.dwellingAddress": "Dwelling Address",
    "Profile_Dwellings_Dwelling.construction": "Construction",
    "Profile_Dwellings_Dwelling.dwellingType": "Dwelling Type",
    "Profile_Dwellings_Dwelling.yearBuilt": "Year Built",
    "Profile_Dwellings_Dwelling.wallFraming": "Wall Framing",
    "Profile_Dwellings_Dwelling.wallExterior": "Wall Exterior",
    "Profile_Dwellings_Dwelling.roofMaterial": "Roof Material",
    "Profile_Dwellings_Dwelling.roofRenovationType": "Roof Renovation Type",
    "Profile_Dwellings_Dwelling.roofRenovationYear": "Roof Renovation Year",
    "Profile_Dwellings_Dwelling.numberOfUnits": "Number of Units",
    "Profile_Dwellings_Dwelling.numberOfStories": "Number of Stories",
    "Profile_Dwellings_Dwelling.numberOfBathrooms": "Number of Bathrooms",
    "Profile_Dwellings_Dwelling.totalLivingArea": "Total Living Area",
    "Profile_Dwellings_Dwelling.finishedBasementPercentage": "Finished Basement %",
    "Profile_Dwellings_Dwelling.occupancy": "Occupancy",
    "Profile_Dwellings_Dwelling.occupancyType": "Occupancy Type",
    "Profile_Dwellings_Dwelling.numberOfFamilies": "Number of Families",
    "Profile_Dwellings_Dwelling.businessActivity": "Business Activity",
    "Profile_Dwellings_Dwelling.smokeFree": "Smoke Free",
    "Profile_Dwellings_Dwelling.electricalSystem": "Electrical System",
    "Profile_Dwellings_Dwelling.wiringType": "Wiring Type",
    "Profile_Dwellings_Dwelling.panelType": "Panel Type",
    "Profile_Dwellings_Dwelling.strength": "Strength",
    "Profile_Dwellings_Dwelling.wiringRenovationType": "Wiring Renovation Type",
    "Profile_Dwellings_Dwelling.wiringRenovationYear": "Wiring Renovation Year",
    "Profile_Dwellings_Dwelling.waterHeatingSystem": "Water Heating System",
    "Profile_Dwellings_Dwelling.waterTankYear": "Water Tank Year",
    "Profile_Dwellings_Dwelling.waterPipeMaterial": "Water Pipe Material",
    "Profile_Dwellings_Dwelling.plumbingRenovationType": "Plumbing Renovation Type",
    "Profile_Dwellings_Dwelling.septicTank": "Septic Tank",
    "Profile_Dwellings_Dwelling.protectionSystems": "Protection Systems",
    "Profile_Dwellings_Dwelling.distanceToFireHydrant": "Distance to Fire Hydrant (m)",
    "Profile_Dwellings_Dwelling.distanceToFireStation": "Distance to Fire Station (km)",
    "Profile_Dwellings_Dwelling.fireAlarm": "Fire Alarm",
    "Profile_Dwellings_Dwelling.numberOfSmokeDetectors": "Number of Smoke Detectors",
    "Profile_Dwellings_Dwelling.sprinklers": "Sprinklers",
    "Profile_Dwellings_Dwelling.sprinklerCoverage": "Sprinkler Coverage",
    "Profile_Dwellings_Dwelling.burglaryAlarm": "Burglary Alarm",
    "Profile_Dwellings_Dwelling.waterMitigationSystems": "Water Mitigation Systems",
    "Profile_Dwellings_Dwelling.heatingSystems": "Heating Systems",
    "Profile_Dwellings_Dwelling.garages": "Garages",
    "Profile_Dwellings_Dwelling.swimmingPools": "Swimming Pools",
    "Profile_Dwellings_Dwelling.scheduledItems": "Scheduled Items",
    "Profile_Dwellings_Dwelling.improvements": "Improvements",
    "Profile_Dwellings_Dwelling.lossPayees": "Loss Payees",
    "Profile_Dwellings_Dwelling.animals": "Animals",
    "Profile_Dwellings_Dwelling.newAnimal": "New Animal",
    "Profile_Dwellings_Dwelling.newHeatingSystem": "New Heating System",
    "Profile_Dwellings_Dwelling.primary": "Primary",
    "Profile_Dwellings_Dwelling.newWaterMitigationSystem": "New Water Mitigation System",
    "Profile_Dwellings_Dwelling.newGarage": "New Garage",
    "Profile_Dwellings_Dwelling.newSwimmingPool": "New Swimming Pool",
    "Profile_Dwellings_Dwelling.newScheduledItem": "New Scheduled Item",
    "Profile_Dwellings_Dwelling.newImprovement": "New Improvement",
    "Profile_Dwellings_Dwelling.newLossPayee": "New Loss Payee"
}
